export enum CONTROL_TYPE {
  RADIO_BUTTON = 'radiobutton',
  TEXT = 'text',
  NUMBER = 'number',
  COMBOBOX = 'combobox',
  CHECKBOX = 'checkbox',
}
